<template>
  <div class="dehn-vform-wrapper">
    <div v-for="(group, groupIndex) in schema" :key="groupIndex">

      <v-form class="dehn-vform" :ref="group.name">
        <!--
        <div class="dehn-vform-loading">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
        </div>-->
        <component v-for="(field, index) in group.children"
                   :key="index"
                   :is="field.type"
                   :value="formData[field.name]"
                   :optionGroups="field.optionGroups"
                   @input="updateForm(field.name, $event)"
                   v-bind="field">
        </component>
      </v-form>
    </div>
  </div>
</template>

<script>
import RadioButton from "./RadioButton";
import Checkbox from "./Checkbox";
export default {
  name: "FormGenerator",
  components: { RadioButton, Checkbox },
  props: ["schema", "value"],
  data() {
    return {
      formData: this.value || {}
    };
  },
  methods: {
    updateForm(fieldName, value) {
      this.$set(this.formData, fieldName, value);
      this.$emit("input", this.formData);
    }
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.formData = val
      }
    },
  }
};
</script>

<style lang="scss">

@import '../../src/sass/variables.scss';

.dehn-vform {
  position: relative;
}

.dehn-vform-loading {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  left: 100px;
}

.wgk-main-group-title {
  color: $c-dehn-text;
}

.wgk-group-title {
  font-size: 15px;
  color: #B2B2B2;
  display: inline-block;
}

</style>
